import type { ReactNode } from "react";
import { LayoutPreview } from "../layout-preview";
import type { SkillDrill } from "../skills/types";
import { DrillIcon } from "./icon";
import { MasteryProgress } from "./mastery";
import { DrillPerformance } from "./performance";

export function DrillCatalogCard({
  drill,
  skills,
  children,
}: {
  drill: SkillDrill;
  skills: SkillDrill["skills"];
  children: ReactNode;
}) {
  return (
    <article className="library-design-drill library-design-drill-row drill-catalog-card">
      <div className="library-design-drill-summary">
        <div className="drill-catalog-selection">{children}</div>
        <div className="library-design-drill-art">
          <LayoutPreview
            id={drill.layout.id}
            revision={drill.layout.revision}
            title={drill.title}
            href={null}
          />
        </div>
        <div className="library-design-drill-body">
          <h3>
            <a
              className="library-design-drill-link"
              href={`/drills/${drill.id}`}
            >
              {drill.title} <DrillIcon name="arrow" size={18} />
            </a>
          </h3>
          <p className="library-design-drill-goal">
            {drill.goal || "配置と成功条件を確認して練習しましょう。"}
          </p>
          <a
            className="drill-catalog-source text-link"
            href={`/drills/collections/${drill.collection.id}`}
          >
            {drill.collection.title}
          </a>
          {skills.length > 0 && (
            <div className="weakness-skill-labels">
              {skills.map((skill) => (
                <span
                  className="weakness-skill-label"
                  key={skill.id}
                  title={skill.categoryLabel}
                >
                  {skill.label}
                </span>
              ))}
            </div>
          )}
          <MasteryProgress drill={drill} compact />
        </div>
      </div>
      <DrillPerformance drill={drill} />
    </article>
  );
}
